import React from 'react'
import Wayfinder from '/js/views/shared/components/wayfinder'
import Logo from '/img/svg/logo'
import { isMobile } from '/js/util'

class Header extends React.Component {
  generateTitle = () => {
    const { header } = this.props

    if (isMobile()) {
      return (
        <>
          <span className="screenreader">Danaher {header.year}</span>
          {header.report_shorthand_name}
        </>
      )
    }

    return (
      <>
        <span className="screenreader">Danaher </span>
        {header.year} {header.report_name}
      </>
    )
  }

  render() {
    const { routes, currentPage, theme } = this.props

    return (
      <header className="bg-white border-b border-columbia-gray relative">
        <div className="px-20">
          <div
            data-label="header-container"
            className="flex justify-between items-center py-15 md:py-30 px-15"
          >
            <a
              href="/"
              data-label="header-title"
              className="font-serif text-16 md:text-18 block font-normal"
            >
              {this.generateTitle()}
            </a>
            <div className="w-100 md:w-135 flex justify-end">
              <a
                className="scale-100 hover:scale-110 transition-normal w-full max-h-50"
                href="http://www.danaher.com/"
              >
                <Logo />
              </a>
            </div>
          </div>
        </div>

        <Wayfinder routes={routes} currentPage={currentPage} theme={theme} />
      </header>
    )
  }
}

export default Header
